import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button, { BorderLessButton } from '../forms/Button';
import useMetronome from '../utility/useMetronome';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';
import Row from '../layout/Row';
import Col from '../layout/Col';
import { generateId, shortHandDate, shortHandDateTimeUTC } from '../utility/functions';
import Icon from '../forms/Icon';
import PageBreak from '../layout/PageBreak';
import LinkTo from '../forms/LinkTo';
import Table from '../table/Table';
import ModalFactory from '../Modal';
import { SCREEN_WIDTH } from '../../constants/config';
import { useGlobalState } from '../stateProvider/StateProvider';

const FootNote = styled.div`
    font-size: 0.7rem;
    font-style: italic;
`;

const SiteStatus = ({ ...props }) => {
    const [data, setData] = useState([]);
    const {
        state: {
            kioskServicesUsage,
        },
    } = useGlobalState();
    const [fetchData, setFetchData] = useState(5);
    const [showKSFootnote, setShowKSFootnote] = useState(false); //denote locations communicating view new kiosk services 


    useEffect(() => {
        const hasNew = Object.values(kioskServicesUsage || {})
            .includes('new');

        setShowKSFootnote(hasNew);
    }, [kioskServicesUsage]);

    const errorIndex = {
        'None': 0,
        'No Status': 1,
        'Unknown': 2,
        'Soft': 3,
        'Hard': 4
    }

    const errorIcon = {
        'None': 'check',
        'No Status': 'questionMark',
        'Unknown': 'questionMark',
        'Soft': 'exclamationTriangle',
        'Hard': 'skull'
    }

    const colorIndex = {
        'None': '#1fab40',
        'No Status': '#ff5700',
        'Unknown': '#ff5700',
        'Soft': '#ffa200',
        'Hard': '#FF0000'
    }

    useMetronome(() => {
        if (fetchData > 0) {
            setFetchData(fetchData - 1)
            HamQuest.get(QuestRoute.dashboard.status)
                .then(res => {
                    res.forEach(loc => {
                        const lastReporting = loc.kiosks.map(e => new Date(e.lastStatusReceivedUtc));
                        loc.lastReporting = SCREEN_WIDTH ? shortHandDate(lastReporting.sort((a, b) => b - a)[0]) : shortHandDateTimeUTC(lastReporting.sort((a, b) => b - a)[0])
                        const errorLevel = loc.kiosks.map(e => e.errorLevel);
                        loc.errorLevel = errorLevel.sort((a, b) => errorIndex[b] - errorIndex[a])[0]
                    })
                    setData(res)
                })
                .catch(ex => console.error(ex))
        }
    }, 60000)

    const ErrorLevel = ({ error }) => (
        <Row>
            <Icon icon={errorIcon[error]} style={{ color: colorIndex[error] }} />
            {error}
        </Row>
    )

   

    const showModal = (loc) => {
        const address = [(loc.address1 + ' ' + (loc.address2 ?? '')).trim(), loc.city.trim(), loc.stateProvince.split('-')[1].trim(), loc.zipPostalCode].join(', ');
        const usesNewKs = kioskServicesUsage?.[loc.locationId] === 'new';
        ModalFactory.show({
            title: `${loc.name}${usesNewKs ? ' *' : ''}`,
            body: (
                <Col>
                    <span><b>Address</b>: {address}</span>
                    <PageBreak padding={0.5}>
                        {loc.kiosks.map(e => (
                            <Row justify='space-between'>
                                <Col>
                                    <span><b>Kiosk</b>: {e.friendlyName}</span>
                                    <span><b>Model</b>: {e.model}</span>
                                    <span><b>Status</b>: {e.statusList.map(e => e.description).join(', ')}</span>
                                </Col>
                                <ErrorLevel error={e.errorLevel} />
                            </Row>
                        ))}
                    </PageBreak>
                </Col>
            )
        })
    }

    return (
        <Col style={{ width: '100%' }}>
            {!fetchData && <Button onClick={() => setFetchData(5)}>Refresh Widget</Button>}
            
            <Table
                config={{
                    disableHeaderSearch: true,
                    disableTableControls: true,
                    disableMobileView: true,
                    data: data,
                    headers: [
                        {
                            label: 'Location',
                            propKey: 'name',
                        }, {
                            label: 'Last Reported',
                            propKey: 'lastReporting',
                        }, {
                            label: 'Error Level',
                            propKey: 'errorLevel',
                        }
                    ],
                    renderFormat: (e) => {
                        const usesNewKS = kioskServicesUsage?.[e.locationId] === 'new';

                        return (
                            <tr key={generateId()}>
                                <td>
                                    <LinkTo to={'/locations#' + e.name.replace(/ /g, '')}>{e.name}</LinkTo>{usesNewKS && ' *'}
                                </td>
                                <td>{e.lastReporting}</td>
                                <td>
                                    <BorderLessButton onClick={() => showModal(e)}>
                                        <ErrorLevel error={e.errorLevel} />
                                    </BorderLessButton>
                                </td>
                            </tr>
                        );
                    }

                }}
            />
            {showKSFootnote && <FootNote>* utilizes new Kiosk Services</FootNote> }
        </Col >
    );
}

export default SiteStatus;